// PR 56 review (22-Oct) · R56-4 — the substantive evidence kinds of a head in scope (substantive coverage / lock check):
// a completed lead sheet with its conclusion (Preparer + Reviewer 1 signed) is the kind "lead_sheet". EN + AR.
// The same words as backend/substantive_coverage.py EVIDENCE_LABEL. Merged into lib/i18n.js (big-file rule).
export const I18N_R564 = {
  en: {
    r564: {
      evidence: {
        lead_sheet: "Lead sheet", sample: "Sample", confirmation: "Confirmation set", worksheet: "Completed worksheet",
        sap: "Substantive analytical procedure", no_further_work: "Reviewer-signed reason",
      },
    },
  },
  ar: {
    r564: {
      evidence: {
        lead_sheet: "الورقة الرئيسية", sample: "عينة", confirmation: "مجموعة مصادقات", worksheet: "ورقة عمل مكتملة",
        sap: "إجراء تحليلي جوهري", no_further_work: "سبب موقّع من المراجع",
      },
    },
  },
};

/** The screen label of one evidence kind (`t` = useI18n().t); an unknown kind shows as stored. */
export function evidenceKindLabel(t, kind) {
  const k = `r564.evidence.${kind}`;
  const v = t(k);
  return v && v !== k ? v : String(kind || "");
}

export default I18N_R564;
